
import { Stethoscope } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from 'react-i18next';

interface ServiceTrackFilterProps {
  selectedTracks: string[];
  onTrackChange: (tracks: string[]) => void;
}

const ServiceTrackFilter = ({ selectedTracks, onTrackChange }: ServiceTrackFilterProps) => {
  const { t } = useTranslation('practitioners');

  const handleTrackToggle = (track: string) => {
    let newTracks: string[];
    
    if (selectedTracks.includes(track)) {
      newTracks = selectedTracks.filter(t => t !== track);
      if (newTracks.length === 0) {
        newTracks = ['clinical', 'wellness'];
      }
    } else {
      newTracks = [...selectedTracks, track];
    }
    
    onTrackChange(newTracks);
  };

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 flex items-center">
        <Stethoscope className="mr-2 h-4 w-4 text-amber-600" /> {t('serviceTrackFilter.title')}
      </h3>
      <div className="flex flex-wrap gap-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="track_clinical"
            checked={selectedTracks.includes('clinical')}
            onCheckedChange={() => handleTrackToggle('clinical')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="track_clinical" className="text-sm font-medium cursor-pointer">
            {t('serviceTrackFilter.clinical')}
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="track_wellness"
            checked={selectedTracks.includes('wellness')}
            onCheckedChange={() => handleTrackToggle('wellness')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="track_wellness" className="text-sm font-medium cursor-pointer">
            {t('serviceTrackFilter.nonClinical')}
          </label>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        {t('serviceTrackFilter.description')}
      </p>
    </div>
  );
};

export default ServiceTrackFilter;
